import {IconName} from '@cov/ui-angular';
import {ASM} from '../../constants';
import type {NavigationItem} from './types/navigation.types';

export const asmNavigation: NavigationItem[] = [
  {
    label: 'navbar.asm',
    route: ASM,
    permissions: [], // Currently no permissions checked, no need
    children: [],
    icon: IconName.APPLICATIONS,
  },
];
